module.exports = __webpack_public_path__ + "static/media/plp-existing-account-login-desktop.bc03544c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plp-existing-account-login-desktop.jpg
// module id = 453
// module chunks = 0